import { getSearchQueryGivenRecordOfQueryParams } from "@faire/retailer-shared/search/searchRequest";
import { useSearchPageQueryIsLoading } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageQueryIsLoading";
import { useSearchPageProductSearchString } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageProductSearchString";
import { getLocation } from "@faire/web--source/common/globals/getLocation";
import qs from "query-string";

export const useSearchPageProductOrParsedSearchString = () => {
  const loading = useSearchPageQueryIsLoading();
  const searchString = useSearchPageProductSearchString();
  const searchLocation = getLocation()?.search;

  /**
   * When search model has not finished loading, then searchString may be "".
   * While the search model is loading, we parse the search term directly from the URL instead,
   * so that it shows up in the initial HTML for SSR.
   */
  const parsedSearch: Record<string, string | undefined> = {
    q: searchString,
    ...qs.parse(searchLocation ?? ""),
  };
  const productOrParsedSearchString: string = loading
    ? getSearchQueryGivenRecordOfQueryParams(parsedSearch)
    : searchString;

  return productOrParsedSearchString;
};
